import { FC, useEffect } from 'react';

import { getStaticPrefix } from '@eneco/common/env';
import useDC from '@eneco/dc/useDC';
import { I18nProvider, useTranslation } from '@eneco/i18n';
import { Skeleton } from '@eneco/sparky';
import { useTracking } from '@eneco/tracking';

import { useMeterReadingsFlow } from '../../../../state/MeterReadingsFlow.machine';
import { Steps } from '../../../../tracking';
import { Breakdown } from '../../../templates/Breakdown';

export const PeriodicPayBackLess: FC = () => {
  const { label } = useDC();

  return (
    <I18nProvider dictionary={locale => import(`./content/PeriodicPayBackLess.${label}.${locale}.json`)}>
      <PeriodicPayBackLessComponent />
    </I18nProvider>
  );
};

export const PeriodicPayBackLessComponent: FC = () => {
  const { label } = useDC();
  const { t, isLoading } = useTranslation();
  const { trackFunnelCompleted } = useTracking();
  const { state } = useMeterReadingsFlow();

  useEffect(() => {
    trackFunnelCompleted({
      step: Steps['THANK_YOU.PeriodicPayBackLess'],
      funnel: state.context.funnelName,
    });
  }, [state.context.funnelName, trackFunnelCompleted]);

  if (isLoading) return <Skeleton height={450} />;

  return (
    <Breakdown
      title={t('periodicPayBackLess.title')}
      content={t('periodicPayBackLess.content')}
      buttonHref={t('periodicPayBackLess.buttonLink.href')}
      buttonText={t('periodicPayBackLess.buttonLink.text')}
      footerLabel={t('periodicPayBackLess.priceDetailsFooterLabel')}
      heroImage={{
        value: {
          src: `${getStaticPrefix()}/images/${label}/meterreadings/${t('periodicPayBackLess.imageSrc')}`,
        },
      }}
    />
  );
};
